/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Utils} from "../../../../common/utils";
import {IC_fsw} from "../../../../models/IC_fsw";

export class Validator_DcDc_Boost extends Validator_DcDc_Buck {

  private validatorFn_SingleOutput_Voltage_Boost: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const _vin = spec.spec.value.input;

    const maxVin: number = (!Utils.isValueEmpty(_vin.max) && !spec.spec.note.input.max.hasError)
      ? _vin.max
      : _vin.min
    ;

    const vOutLowerBound: number = Math.max(ic.vout_min, Math.round(maxVin / (new IC_fsw(ic).dMax) * 100) / 100);
    const vOutUpperBound: number = ic.vout_max;

    const result = Utils.acceptInRange(_vOut, vOutLowerBound, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_Boost];
  }
}
